/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-misused-promises */
import React, { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Modal, Row, Table, Dropdown } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import {
  Button,
  PageHeader,
  Pagination,
} from '@cloudcar-app/cloudcar-components';
import { formatRut, validateRut } from '@abstract-cl/rut-ts';
import { useLazyQuery } from '@apollo/client';
import {
  Car,
  Insurance,
  LitePurchaseIntent,
  LitePurchaseIntentConnection,
  LitePurchaseIntentCursor,
  LitePurchaseIntentCursorInput,
} from 'apollo/types';
import operations from 'apollo/operations';
import dateFormatter from 'utils/dateFormatter';
import { getDealerFromIdToken, getRoleFromIdToken } from 'utils/getDataFromJwt';
import {
  PurchaseIntentRangePicker,
  PurchaseIntentSearch,
} from 'components/purchaseIntentList';
import dayjs from 'dayjs';
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import styles from './PurchaseIntentList.module.scss';

const PurchaseIntentList: FC = () => {
  const history = useHistory();
  const [
    showLitePurchaseIntentDownloadButton,
    setShowLitePurchaseIntentDownloadButton,
  ] = useState(false);

  const [showInsuranceProposal, setShowInsuranceProposal] = useState(false);
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [nextCursor, setNextCursor] = useState<
    LitePurchaseIntentCursor | undefined | null
  >(undefined);

  const [pageSize, setPageSize] = useState<number>(10);
  const [modalVisible, setModalVisible] = useState(false);
  const [proposalModal, setProposalModal] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(-1);
  const [showRangePickerModal, setShowRangePickerModal] = useState(false);
  const [cursorList, setCursorList] = useState<LitePurchaseIntentCursor[]>([]);
  const [hasPrevPage, setHasPrevPage] = useState<boolean>(false);
  const [startDateString, setStartDateString] = useState<string>(
    dayjs().startOf('day').toISOString(),
  );

  const [endDateString, setEndDateString] = useState<string>(
    dayjs().toISOString(),
  );

  const [hasNextPage, setHasNextPage] = useState<boolean>(false);
  const [litePurchaseIntentList, setLitePurchaseIntentList] = useState<
    null | LitePurchaseIntent[]
  >(null);

  const [
    listPurchaseIntentInCsv,
    {
      data: listLitePurchaseIntentToCsvData,
      loading: csvLitePurchaseIntentLoading,
    },
  ] = useLazyQuery<{
    listLitePurchaseIntentToCsv: string;
  }>(operations.LIST_LITE_PURCHASE_INTENT_TO_CSV, {
    fetchPolicy: 'network-only',
  });

  const [
    listProposalCsv,
    { data: listInsuranceProposalToCsv, loading: csvProposalLoading },
  ] = useLazyQuery<{
    listInsuranceProposalToCsv: string;
  }>(operations.LIST_INSURANCE_PROPOSAL_TO_CSV, {
    fetchPolicy: 'network-only',
  });

  const [
    lisPurchaseCsv,
    { data: listPurchaseToCsv, loading: csvPurchaseLoading },
  ] = useLazyQuery<{
    listPurchaseToCsv: string;
  }>(operations.LIST_PURCHASE_TO_CSV, {
    fetchPolicy: 'network-only',
  });
  const [listPurchaseIntent, { data: liteData, loading: liteLoading }] =
    useLazyQuery<{
      paginateLitePurchaseIntent: LitePurchaseIntentConnection;
    }>(operations.GET_ALL_LITE_PURCHASE_INTENT, {
      fetchPolicy: 'network-only',
    });

  const handleNextPage = () => {
    let litePurchaseIntentCursorInput: LitePurchaseIntentCursorInput = {};
    if (nextCursor) {
      litePurchaseIntentCursorInput = {
        ...litePurchaseIntentCursorInput,
        createdAt: nextCursor.createdAt,
        purchaseIntentId: nextCursor.purchaseIntentId,
      };
    }

    listPurchaseIntent({
      variables: {
        first: pageSize,
        after: litePurchaseIntentCursorInput,
      },
    });
    setCurrentPage(currentPage + 1);
  };

  const handleLitePurchaseIntentCsv = async () => {
    await listPurchaseIntentInCsv({
      variables: {
        dateRange: [startDateString, endDateString],
      },
    });
  };

  const handleProposalCsv = async () => {
    await listProposalCsv({
      variables: {
        dateRange: [startDateString, endDateString],
      },
    });
  };

  const handlePurchaseCsv = async () => {
    await lisPurchaseCsv({
      variables: {
        dateRange: [startDateString, endDateString],
      },
    });
  };

  const setLitePurchaseIntentCsvDataFunction = () => {
    if (
      listLitePurchaseIntentToCsvData &&
      listLitePurchaseIntentToCsvData.listLitePurchaseIntentToCsv
    ) {
      const csvData = new Blob(
        [listLitePurchaseIntentToCsvData.listLitePurchaseIntentToCsv],
        {
          type: 'text/csv;charset=utf-8;',
        },
      );
      // IE11 & Edge
      if ((navigator as any).msSaveBlob) {
        (navigator as any).msSaveBlob(csvData, 'reporte.csv');
      } else {
        // In FF link must be added to DOM to be clicked
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(csvData);
        link.setAttribute('download', 'reporte.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  const setProposalCsvDataFunction = () => {
    if (
      listInsuranceProposalToCsv &&
      listInsuranceProposalToCsv.listInsuranceProposalToCsv
    ) {
      const csvData = new Blob(
        [listInsuranceProposalToCsv.listInsuranceProposalToCsv],
        {
          type: 'text/csv;charset=utf-8;',
        },
      );
      // IE11 & Edge
      if ((navigator as any).msSaveBlob) {
        (navigator as any).msSaveBlob(csvData, 'reporte.csv');
      } else {
        // In FF link must be added to DOM to be clicked
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(csvData);
        link.setAttribute('download', 'reporte.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  const setPurchaseCsvDataFunction = () => {
    if (listPurchaseToCsv && listPurchaseToCsv.listPurchaseToCsv) {
      const csvData = new Blob([listPurchaseToCsv.listPurchaseToCsv], {
        type: 'text/csv;charset=utf-8;',
      });
      // IE11 & Edge
      if ((navigator as any).msSaveBlob) {
        (navigator as any).msSaveBlob(csvData, 'reporte.csv');
      } else {
        // In FF link must be added to DOM to be clicked
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(csvData);
        link.setAttribute('download', 'reporte.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  const checkIfUserIsAllowedToDownloadPurchaseIntent = () => {
    const role = getRoleFromIdToken();

    if (role === 'super-admin') {
      setShowLitePurchaseIntentDownloadButton(true);
    }

    if (role === 'usuario-seguros') {
      setShowInsuranceProposal(true);
    }
  };

  const handlePrevPage = () => {
    let litePurchaseIntentCursorInput: LitePurchaseIntentCursorInput = {};
    if (currentPage > 1) {
      litePurchaseIntentCursorInput = {
        ...litePurchaseIntentCursorInput,
        createdAt: cursorList[currentPage - 2].createdAt,
        purchaseIntentId: cursorList[currentPage - 2].purchaseIntentId,
      };
    }

    listPurchaseIntent({
      variables: {
        first: pageSize,
        after: litePurchaseIntentCursorInput,
      },
    });
    setCurrentPage(currentPage - 1);
  };

  useEffect(() => {
    listPurchaseIntent({
      variables: {
        first: pageSize,
        after: {},
      },
    });
  }, []);

  const handleLitePurchaseIntentData = () => {
    if (liteData && liteData.paginateLitePurchaseIntent) {
      const litePurchaseIntents = liteData.paginateLitePurchaseIntent.edges.map(
        (edge) => edge.node,
      );

      setLitePurchaseIntentList(litePurchaseIntents);
      setNextCursor(liteData.paginateLitePurchaseIntent.pageInfo.endCursor);
      setHasNextPage(liteData.paginateLitePurchaseIntent.pageInfo.hasNextPage);
      let page = currentPage;
      if (currentPage === -1) {
        setCurrentPage(0);
        page = 0;
      }
      setHasPrevPage(page > 0);
      if (
        liteData.paginateLitePurchaseIntent.pageInfo.endCursor &&
        page + 1 > cursorList.length
      ) {
        setCursorList([
          ...cursorList,
          liteData.paginateLitePurchaseIntent.pageInfo.endCursor,
        ]);
      }
    }
  };

  useEffect(() => {
    const litePurchaseIntentCursorInput: LitePurchaseIntentCursorInput = {};

    listPurchaseIntent({
      variables: {
        first: pageSize,
        after: litePurchaseIntentCursorInput,
      },
    });
    setCurrentPage(0);
    setCursorList([]);
  }, [pageSize]);

  useEffect(() => {
    handleLitePurchaseIntentData();
  }, [liteData, liteLoading]);

  useEffect(() => {
    if (!csvLitePurchaseIntentLoading) {
      setLitePurchaseIntentCsvDataFunction();
    }
  }, [csvLitePurchaseIntentLoading]);

  useEffect(() => {
    if (!csvProposalLoading) {
      setProposalCsvDataFunction();
    }
  }, [csvProposalLoading]);

  useEffect(() => {
    if (!csvPurchaseLoading) {
      setPurchaseCsvDataFunction();
    }
  }, [csvPurchaseLoading]);

  useEffect(() => {
    checkIfUserIsAllowedToDownloadPurchaseIntent();
  }, []);

  const columns: ColumnsType<LitePurchaseIntent> = [
    {
      title: 'Fecha',
      align: 'center',
      dataIndex: 'createdAt',
      render: (createdAt: string) => <p>{dateFormatter(createdAt)}</p>,
      sorter: (a: LitePurchaseIntent, b: LitePurchaseIntent) =>
        (a.createdAt || '').toString().localeCompare(b.createdAt || ''),
      defaultSortOrder: 'descend',
    },
    {
      title: 'Rut cliente',
      align: 'center',
      dataIndex: 'customerRut',
      render: (clientRut: string) =>
        validateRut(clientRut) ? formatRut(clientRut) : clientRut,
      sorter: (a: LitePurchaseIntent, b: LitePurchaseIntent) =>
        (a.customerRut as string).localeCompare(b.customerRut as string),
    },
    {
      title: 'Seguros',
      align: 'center',
      dataIndex: 'insurance',
      render: (insurance: Insurance) => <p>{insurance ? 'Si' : 'No'}</p>,
    },
    {
      title: 'Modelo',
      align: 'center',
      dataIndex: 'car',
      render: (car: Car) => car.model,
    },
    {
      title: 'CIT',
      align: 'center',
      dataIndex: 'car',
      render: (car?: Car) => {
        if (car) {
          return car.cit;
        }
        return '-';
      },
      sorter: (a: LitePurchaseIntent, b: LitePurchaseIntent) =>
        (a.car ? a.car.cit || '-' : '-').localeCompare(
          b.car ? b.car.cit || '-' : '-',
        ),
    },
    {
      align: 'right',
      render: (record: LitePurchaseIntent) => (
        <Button
          mode="text"
          onClick={() => {
            localStorage.setItem('customerRut', record.customerRut || '');
            localStorage.setItem('purchaseIntentId', record.purchaseIntentId);
            localStorage.setItem('dealer', getDealerFromIdToken() || '');
            history.push({
              pathname: record.operationalCosts
                ? '/procedureSelection'
                : '/insuranceSimulation',
              state: {
                from: history.location,
              },
            });
            localStorage.setItem('detailsInViewMode', 'true');
          }}
        >
          Ver detalles
        </Button>
      ),
    },
  ];

  const removeStorage = () => {
    localStorage.removeItem('purchaseIntentId');
    localStorage.removeItem('dealer');
  };

  const getHandler = () => {
    if (purchaseModal) {
      return handlePurchaseCsv;
    }
    if (proposalModal) {
      return handleProposalCsv;
    }
    return handleLitePurchaseIntentCsv;
  };

  const getOptions = () => {
    if (showLitePurchaseIntentDownloadButton) {
      return [
        {
          key: '1',
          label: (
            <a
              onClick={() => {
                removeStorage();
                history.push({
                  pathname: '/insuranceProposal',
                  state: {
                    from: history.location,
                  },
                });
              }}
            >
              Propuesta seguro
            </a>
          ),
        },
        {
          key: '2',
          label: (
            <a onClick={() => setShowRangePickerModal(true)}>
              Descargar solicitudes
            </a>
          ),
        },
        {
          key: '3',
          label: (
            <a
              onClick={() => {
                setShowRangePickerModal(true);
                setPurchaseModal(true);
              }}
            >
              Descargar ventas
            </a>
          ),
        },
        {
          key: '4',
          label: (
            <a
              onClick={() => {
                setShowRangePickerModal(true);
                setProposalModal(true);
              }}
            >
              Descargar consolidado polizas
            </a>
          ),
        },
        {
          key: '5',
          label: <a onClick={() => history.push('/users')}>Usuarios</a>,
        },
        {
          key: '5',
          label: (
            <a
              onClick={() => {
                setModalVisible(true);
              }}
            >
              Buscar solicitud
            </a>
          ),
        },
      ];
    }
    if (showInsuranceProposal) {
      return [
        {
          key: '1',
          label: (
            <a
              onClick={() => {
                removeStorage();
                history.push({
                  pathname: '/insuranceProposal',
                  state: {
                    from: history.location,
                  },
                });
              }}
            >
              Propuesta seguro
            </a>
          ),
        },
        {
          key: '2',
          label: (
            <a
              onClick={() => {
                setModalVisible(true);
              }}
            >
              Buscar solicitud
            </a>
          ),
        },
      ];
    }
    if (showInsuranceProposal) {
      return [
        {
          key: '1',
          label: (
            <a
              onClick={() => {
                removeStorage();
                history.push({
                  pathname: '/insuranceProposal',
                  state: {
                    from: history.location,
                  },
                });
              }}
            >
              Propuesta seguro
            </a>
          ),
        },
        {
          key: '1',
          label: (
            <a
              onClick={() => {
                setModalVisible(true);
              }}
            >
              Buscar solicitud
            </a>
          ),
        },
      ];
    }
    return [
      {
        key: '1',
        label: (
          <a
            onClick={() => {
              setModalVisible(true);
            }}
          >
            Buscar solicitud
          </a>
        ),
      },
    ];
  };

  return (
    <>
      <Row justify="space-between" align="middle">
        <Modal
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          footer={null}
          centered
          width="30%"
          closable={false}
          bodyStyle={{ padding: '0', borderRadius: '12px' }}
          maskStyle={{ backdropFilter: 'blur(8px)' }}
        >
          <PurchaseIntentSearch />
        </Modal>
        <PageHeader title="Historial de solicitudes" />
        <Row>
          {showRangePickerModal && (
            <PurchaseIntentRangePicker
              csvListLoading={
                csvLitePurchaseIntentLoading ||
                csvProposalLoading ||
                csvPurchaseLoading
              }
              handleLitePurchaseIntentCsv={getHandler()}
              visible={showRangePickerModal}
              onClose={() => {
                setShowRangePickerModal(false);
                setProposalModal(false);
                setPurchaseModal(false);
              }}
              setStartDateString={setStartDateString}
              setEndDateString={setEndDateString}
            />
          )}
          <Button
            style={{ marginRight: '12px' }}
            onClick={() => {
              removeStorage();
              history.push({
                pathname: '/newPurchaseIntent',
                state: {
                  from: history.location,
                },
              });
            }}
          >
            Nueva solicitud
            <PlusOutlined />
          </Button>
          <Dropdown menu={{ items: getOptions() }}>
            <Button className={styles.Menu} onClick={(e) => e.preventDefault()}>
              Acciones
              <DownOutlined />
            </Button>
          </Dropdown>
        </Row>
      </Row>
      <Row justify="center" className={styles.TableContainer}>
        <Table
          loading={liteLoading}
          columns={columns}
          dataSource={litePurchaseIntentList || []}
          rowKey={(record) => record.purchaseIntentId}
          pagination={false}
        />
      </Row>
      <Row justify="end" className={styles.PaginationContainer}>
        <Pagination
          hasPrevPage={hasPrevPage}
          hasNextPage={hasNextPage}
          onNextPage={handleNextPage}
          onPrevPage={handlePrevPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          pageSizeOptions={[10, 20, 50, 100]}
          showSizeChanger
        />
      </Row>
    </>
  );
};

export default PurchaseIntentList;
